/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSaveChatMessagesHintsByOfferModel,
  ISaveChatMessagesHintsByOfferRequest,
  IMappers,
  ISaveChatMessagesHintsByOfferResponse,
  ISaveChatMessagesHintsByOfferResponseError,
  TSaveChatMessagesHintsByOfferResponse,
} from './types';

const defaultConfig: TSaveChatMessagesHintsByOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/save-chat-messages-hints-by-offer/',
  hostType: 'api',
} as TSaveChatMessagesHintsByOfferModel;

function createSaveChatMessagesHintsByOfferModel(
  parameters: ISaveChatMessagesHintsByOfferRequest,
): TSaveChatMessagesHintsByOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISaveChatMessagesHintsByOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISaveChatMessagesHintsByOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSaveChatMessagesHintsByOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISaveChatMessagesHintsByOfferOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSaveChatMessagesHintsByOfferResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSaveChatMessagesHintsByOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISaveChatMessagesHintsByOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISaveChatMessagesHintsByOfferResponseError);
    }
  }

  return { response, statusCode } as TSaveChatMessagesHintsByOfferResponse;
}

export { defaultConfig, createSaveChatMessagesHintsByOfferModel, fetchSaveChatMessagesHintsByOffer };
